import React from 'react';
import { motion } from 'framer-motion';
import { FaTimes, FaCheck, FaExclamationTriangle, FaInfoCircle } from 'react-icons/fa';

const Toast = ({ id, message, type = 'info', onClose }) => {
  const typeStyles = {
    success: {
      bg: 'bg-green-500',
      icon: FaCheck,
      iconColor: 'text-white'
    },
    error: {
      bg: 'bg-red-500',
      icon: FaTimes,
      iconColor: 'text-white'
    },
    warning: {
      bg: 'bg-yellow-500',
      icon: FaExclamationTriangle,
      iconColor: 'text-white'
    },
    info: {
      bg: 'bg-blue-500',
      icon: FaInfoCircle,
      iconColor: 'text-white'
    }
  };

  const { bg: backgroundClass, icon: Icon, iconColor } = typeStyles[type];

  return (
    <motion.div
      initial={{ opacity: 0, y: 50, scale: 0.3 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      exit={{ opacity: 0, y: 50, scale: 0.3 }}
      transition={{ duration: 0.3 }}
      className={`${backgroundClass} text-white px-6 py-4 rounded-lg shadow-lg flex items-center space-x-3 min-w-[300px] max-w-md`}
    >
      <Icon className={`flex-shrink-0 ${iconColor}`} size={20} />
      <div className="flex-1">
        <p className="text-sm font-medium">{message}</p>
      </div>
      <button
        onClick={() => onClose(id)}
        className="ml-4 text-white/80 hover:text-white transition-colors"
        aria-label="Close notification"
      >
        <FaTimes size={14} />
      </button>
    </motion.div>
  );
};

const ToastContainer = () => {
  return (
    <div className="fixed top-4 right-4 z-50 space-y-2 pointer-events-none">
      {/* Toast notifications will be rendered here by the ToastProvider */}
    </div>
  );
};

export { Toast, ToastContainer };